import { BRAND_OG_IMAGE_URL, BRAND_PERSON_NAME, BRAND_SITE_URL } from "@/lib/brandConfig";
import profileImage from "@/assets/profile-delfu.jpg";
import reel1 from "@/assets/reel-1.jpg";
import reel2 from "@/assets/reel-2.jpg";
import reel3 from "@/assets/reel-3.jpg";
import { BaseTemplate } from "@/components/templates/BaseTemplate";
import { BioLinkTemplate } from "@/components/templates/BioLinkTemplate";
import { useTemplateSelection } from "@/hooks/useTemplateSelection";
import { useSEO } from "@/hooks/useSEO";

type MediaItem = {
  id: number;
  type: "video" | "photo";
  src: string;
  embedId?: string;  // For Streamable videos
  cloudflareId?: string;  // For Cloudflare Stream videos
  title: string;
};

const mediaItems: MediaItem[] = [
  { 
    id: 1, 
    type: "video", 
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/55af92c0a6afac58e780413127c73c5c/thumbnails/thumbnail.jpg", 
    cloudflareId: "55af92c0a6afac58e780413127c73c5c", 
    title: "" 
  },
  { 
    id: 2, 
    type: "video", 
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/27cbea077c11d9cc0569774b8c443a04/thumbnails/thumbnail.jpg", 
    cloudflareId: "27cbea077c11d9cc0569774b8c443a04", 
    title: "" 
  },
  { 
    id: 3, 
    type: "video", 
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/55af92c0a6afac58e780413127c73c5c/thumbnails/thumbnail.jpg", 
    cloudflareId: "55af92c0a6afac58e780413127c73c5c", 
    title: "" 
  },
  {
    id: 4,
    type: "photo",
    src: reel1,
    title: "Fashion Style"
  },
  {
    id: 5,
    type: "photo",
    src: reel2,
    title: "Outfit Inspiration"
  },
  {
    id: 6,
    type: "photo",
    src: profileImage,
    title: "Fashion Portrait"
  },
  {
    id: 7,
    type: "video",
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/27cbea077c11d9cc0569774b8c443a04/thumbnails/thumbnail.jpg",
    cloudflareId: "27cbea077c11d9cc0569774b8c443a04",
    title: ""
  },
  {
    id: 8,
    type: "photo",
    src: reel3,
    title: "Style Showcase"
  },
  {
    id: 9,
    type: "photo",
    src: "https://imagedelivery.net/N5r9mtOgBIolYeX8w64oqg/e9f2e4fc-fbf1-4ead-6e36-c8d2b9917d00/public",
    title: "Fashion Lifestyle"
  },
  {
    id: 10,
    type: "photo",
    src: "https://imagedelivery.net/N5r9mtOgBIolYeX8w64oqg/5693d23a-20a6-4e89-9cb9-806ca3ccc900/public",
    title: "Style Portrait"
  },
  {
    id: 11,
    type: "photo",
    src: "https://imagedelivery.net/N5r9mtOgBIolYeX8w64oqg/2fe5d4c8-fefd-49a3-c53b-6736465a1b00/public",
    title: "Fashion Studio"
  },
  {
    id: 12,
    type: "video",
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/0599f80309c4103f7ebe835cf09f5a41/thumbnails/thumbnail.jpg",
    cloudflareId: "0599f80309c4103f7ebe835cf09f5a41",
    title: ""
  },
  {
    id: 13,
    type: "video",
    src: "https://customer-zxw1qxgyoag8tcec.cloudflarestream.com/905a888c2c2c99b75ac5c03f3ab98aaa/thumbnails/thumbnail.jpg",
    cloudflareId: "905a888c2c2c99b75ac5c03f3ab98aaa",
    title: ""
  },
];

export const Fashion = () => {
  const { region, shouldUseBaseTemplate, shouldUseBioLinkTemplate } = useTemplateSelection();

  // Enhanced SEO configuration with Fashion focus
  const seoConfig = {
    title: region === "US" 
      ? `${BRAND_PERSON_NAME} | Fashion & Style Content Creator - Join My Community`
      : `${BRAND_PERSON_NAME} - Fashion | Moda, Style y Tendencias Argentina`,
    description: region === "US" 
      ? `Join fashion content creator ${BRAND_PERSON_NAME}'s exclusive community! Get access to premium fashion content, style tips, outfit inspiration, and connect directly. Your gateway to exclusive fashion and style content.`
      : `${BRAND_PERSON_NAME} moda y fashion. Tendencias, outfit ideas, consejos de style y inspiración fashion. Contenido de moda auténtico desde Argentina.`,
    keywords: region === "US"
      ? `${BRAND_PERSON_NAME}, fashion, style, fashion content creator, premium fashion content, exclusive access, style tips, outfit inspiration, fashion trends, content creator`
      : `moda, fashion, ${BRAND_PERSON_NAME} moda, argentina fashion, style, tendencias, outfits, consejos moda, inspiracion fashion, looks, styling`,
    ogImage: BRAND_OG_IMAGE_URL,
    ogTitle: region === "US"
      ? `${BRAND_PERSON_NAME} | Fashion & Style Content Creator - Join My Community`
      : `${BRAND_PERSON_NAME} - Fashion`,
    ogDescription: region === "US"
      ? "Join my exclusive community! Premium fashion content, style tips, outfit inspiration, and direct connection. Let's create stylish content together! 👗✨"
      : "Contenido de moda y fashion auténtico. Tendencias, outfit ideas y consejos de style que inspiran confianza y expresión personal.",
    canonical: `${BRAND_SITE_URL}/fashion`,
    author: BRAND_PERSON_NAME,
    publishedTime: "2026-01-01T00:00:00.000Z",
    modifiedTime: new Date().toISOString(),
    type: region === "US" ? "profile" : "website",
    locale: region === "US" ? "en_US" : "es_AR",
    alternateLocale: region === "US" ? "es_AR" : "en_US",
  };

  useSEO(seoConfig);

  // Use template based on feature flags
  if (shouldUseBioLinkTemplate()) {
    return <BioLinkTemplate mediaItems={mediaItems} />;
  }

  // Default to BaseTemplate (LATAM style)
  return <BaseTemplate mediaItems={mediaItems} />;
};

export default Fashion;